import { NoInfoDataBlock } from "./NoInfoDataBlock";
import { GetMoreContactsForAccountsBtn } from "../ui/GetMoreContactsForAccountsBtn";

type Props = {
  campaign_id: string;
  totalAccounts: number;
};

export const NoContactsDataBlock = ({ campaign_id, totalAccounts }: Props) => {
  return (
    <NoInfoDataBlock
      campaign_id={campaign_id}
      totalAccounts={totalAccounts}
      title="No Contacts Data"
      description={
        "Gain buying committee insights by running an up-to-date contact search."
      }
      buttonText="Upload Contacts List"
      onClick={() => {}}
      btnBlock={
        <GetMoreContactsForAccountsBtn
          fullWidth={true}
          campaign_id={campaign_id}
        />
      }
    />
  );
};
